import { React, useState, Fragment } from 'react';
import { useForm, Controller } from 'react-hook-form';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import TopActions from '../actions/TopActions';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import TextField from '@mui/material/TextField';
import Toast from '../actions/Toasts';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import apiService from '../../services/apiServices';
import templateValidationSchema from '../../services/templateValidationSchema';
import InputController from '../../controllers/InputController';
import { yupResolver } from '@hookform/resolvers/yup';
//import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState } from 'draft-js';
import { convertToHTML } from 'draft-convert';
import EditorTemplate from '../document-editor/Editor';

const AddTemplate = () => {
  const alert = { open: false, message: '', variant: '' };
  const [toast, setToast] = useState(alert);

  const [editorState, setEditorState] = useState(EditorState.createEmpty())
  const {
    register,
    handleSubmit,
    control,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(templateValidationSchema),
  });

  const copyTag = (e) => {
    navigator.clipboard.writeText(e.target.innerHTML);
  }

  const tags = ["FirstName", "LastName", "ParentName", "PersonalId", "Address", "Phone", "PostalCode", "BankAccount", "BankName", "Birthday", "Country", "Place", "Email", "Gender", "MaritalStatus", "Qualification", "ContractType", "StartDate", "EndDate", "WorkType", "SalaryType", "Department", "BaseSalary", "BrutoNeto", "HourSalary", "HourSalaryWeekend", "HourSalaryHoliday", "TermsOfContract"]

  const generateTagButton = () => {
    return tags?.map(tag => {
      return <div className='tooltip'><button type='button' className='btn-tag' id={tag} onClick={(e) => copyTag(e)}>
        {`@${tag}`}
      </button>
        <small class="tooltiptext">Click to copy {`@${tag}`}</small></div>
    })
  }

  const onSubmit = (data) => {
    apiService().post('contractsTemplates', data)
      .then((response) => {
        if (response.success) {
          setToast({
            open: true,
            message: 'U ruajten me sukses!',
            variant: 'success',
          });
        } else {
          setToast({
            open: true,
            message: 'Ka ndodhur nje gabim!',
            variant: 'error',
          });
        }
      });
  };

  const onEditorStateChange = (editorState) => {
    console.log(convertToHTML(editorState.getCurrentContent()))
    setValue('Text', convertToHTML(editorState.getCurrentContent()))
    setEditorState(editorState)
  };

  return (
    <div>
      <Fragment>
        <Toast {...toast} />
        <TopActions
          newHref="/contracts-templates/addTemplate"
          save={handleSubmit(onSubmit)}
        />

        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Të dhënat
            </Typography>
            <form>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} lg={12}>
                  <InputController
                    placeholder="Emertimi"
                    error={errors.Name}
                    control={control}
                    register={{ ...register('Name') }}
                    name="Name"
                    type="text"
                  />
                </Grid>
                <Grid item xs={12} sm={12} lg={12}>
                  <small style={{ fontStyle: 'italic' }}>Perdorni tagat {generateTagButton()} per te lexuar te dhanat nga sistemi!</small>
                </Grid>
                <Grid item xs={12} sm={12} lg={12}>
                  <EditorTemplate name="Text" value={watch('Text')} getBackData={(text) => setValue('Text', text)} />
                </Grid>
                {/* <Grid item xs={12} sm={12} lg={12}>
                      <Editor
                        editorState={editorState}
                        toolbarClassName="toolbarClassName"
                        wrapperClassName="wrapperClassName"
                        editorClassName="editorClassName"
                        onEditorStateChange={onEditorStateChange}
                      />
                    </Grid> */}

              </Grid>
            </form>
          </CardContent>
        </Card>
      </Fragment>
    </div>
  )
}

export default AddTemplate